"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReplicaReportGroupingResponseSchema = exports.ReplicaReportGroupingSchema = exports.ReplicaReportSummaryResponseSchema = exports.ReplicaReportSummaryValuesSchema = exports.ReplicaReportFields = exports.AnyObjectTypeSchema = exports.ReplicaReportValuesSchema = exports.ReplicaReportValueFields = exports.ReplicaReportSummaryFields = void 0;
const typebox_1 = require("@sinclair/typebox");
const core_1 = require("../../../core");
/** Replica report values which appear through aggregations  */
exports.ReplicaReportSummaryFields = {
    impressions: core_1.CountSchema,
    tapInstalls: core_1.CountSchema,
    tapNewDownloads: core_1.CountSchema,
    tapRedownloads: core_1.CountSchema,
    spend: core_1.MoneySchema,
    taps: core_1.CountSchema,
    viewInstalls: core_1.CountSchema,
    viewNewDownloads: core_1.CountSchema,
    viewRedownloads: core_1.CountSchema,
};
/** Replica report values which appear when get or listing */
exports.ReplicaReportValueFields = {
    ...exports.ReplicaReportSummaryFields,
    tapInstallCPI: core_1.MoneySchema,
    cpmAvg: core_1.MoneySchema,
    cptAvg: core_1.MoneySchema,
    // These only appear on keyword reports, and even then they might optional,
    // However for simplicity we have them on all reports.
    minBidRecommendation: typebox_1.Type.Optional(core_1.MoneySchema),
    maxBidRecommendation: typebox_1.Type.Optional(core_1.MoneySchema),
    suggestedBidRecommendation: typebox_1.Type.Optional(core_1.MoneySchema),
    bidAmount: typebox_1.Type.Optional(core_1.MoneySchema),
};
exports.ReplicaReportValuesSchema = (0, core_1.StrictObject)({
    ...exports.ReplicaReportValueFields,
});
exports.AnyObjectTypeSchema = (0, core_1.JSONObject)({}, {
    title: "Original Report Row",
    description: "The original report row object fetched from Apple ASA",
});
exports.ReplicaReportFields = {
    values: exports.ReplicaReportValuesSchema,
    period: core_1.TimestampSchema,
    // Technically this is something lie CampaignReportRowSchema, but we don't validate what is going in
    body: exports.AnyObjectTypeSchema,
};
exports.ReplicaReportSummaryValuesSchema = (0, core_1.StrictObject)({
    ...exports.ReplicaReportSummaryFields,
});
exports.ReplicaReportSummaryResponseSchema = (0, core_1.StrictObject)({
    totals: exports.ReplicaReportSummaryValuesSchema,
    count: core_1.CountSchema,
});
exports.ReplicaReportGroupingSchema = (0, core_1.StrictObject)({
    key: typebox_1.Type.String(),
    value: exports.ReplicaReportSummaryValuesSchema,
    count: core_1.CountSchema,
});
exports.ReplicaReportGroupingResponseSchema = (0, core_1.StrictObject)({
    groups: typebox_1.Type.Array(exports.ReplicaReportGroupingSchema),
});
